import { EvaluationDetails } from './evaluation-details.model';
import { CalculationResult } from './observation.focus.summary.model';

export interface FocusSummaryState {
    evaluationsDetails?: EvaluationDetails[];
    calculationResult?: CalculationResult;
}

export const defaultFocusSummaryState = (): FocusSummaryState => ({});
